/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PDFExportPanel from '../../../SharedModules/pdfExport/PDFExportPanel';

const customProcessCellCallback = (params) => {
  if (params.column.colDef.pdfExportOptions?.skipColumn) {
    return null;
  }
  return params.value;
};

const customProcessHeaderCallback = (params) => {
  if (params.column.colDef.pdfExportOptions?.skipColumn) {
    return '';
  }
  return params.column.getColDef().headerName;
};

const TableFilterHeader = ({
  addRecordLabel = '',
  gridApi,
  columnApi,
  fileName,
  childRef,
  showResetFilter = true,
  showHistory = true,
  showExport = true,
  showFullScreen = true,
  applyFilter,
  fullScreen,
  setFullScreen,
  isCustomFunc = true,
  resetFilterFunc = () => {},
  addRecordFunc = () => {},
  className = '',
  csvParams = {},
}) => {
  return (
    <div
      className={`d-flex align-items-center mb-1 justify-content-between filter-container ${className}`}
    >
      <div className="tBillPanel pb-0 mb-3">
        {addRecordLabel && (
          <Link
            to="#"
            className="icon-plus float-center btn-plus"
            data-testid="add-bankckrupty"
            role="button"
            onClick={addRecordFunc}
          >
            <span>{addRecordLabel}</span>
          </Link>
        )}
      </div>
      <div className="d-flex align-items-center th-icon-group">
        {showResetFilter && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="filter-tooltip">Reset All Filters</Tooltip>}
          >
            {applyFilter ? (
              <div
                className="th-icon ic-filter-activate"
                data-testid="handleClearFilter"
                role="button"
                onClick={resetFilterFunc}
              >
                <span className="ic-title"> Filter </span>{' '}
              </div>
            ) : (
              <div className="th-icon ic-filter">
                <span className="ic-title"> Filter </span>{' '}
              </div>
            )}
          </OverlayTrigger>
        )}
        {showHistory && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="history-tooltip">View History</Tooltip>}
          >
            <div className="th-icon ic-history" onClick={() => {}}>
              <span className="ic-title"> History </span>
            </div>
          </OverlayTrigger>
        )}
        {showExport && gridApi && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
          >
            <div className="th-icon ic-actions">
              <PDFExportPanel
                gridApi={gridApi}
                columnApi={columnApi}
                fileName={fileName}
                childRef={childRef}
                ExportCsv={() => {
                  return gridApi.exportDataAsCsv({
                    fileName: `${fileName ? `${fileName}.csv` : 'data.csv'}`,
                    processCellCallback: customProcessCellCallback,
                    processHeaderCallback: customProcessHeaderCallback,
                    ...csvParams,
                  });
                }}
                isCustomFunc={isCustomFunc}
                ExportExcel={() => {
                  return (
                    gridApi &&
                    gridApi.getDataAsCsv({
                      processCellCallback: customProcessCellCallback,
                      processHeaderCallback: customProcessHeaderCallback,
                      ...csvParams,
                    })
                  );
                }}
              />
            </div>
          </OverlayTrigger>
        )}
        {showFullScreen && (
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="fullScreen-tooltip">
                {fullScreen ? 'Minimize Screen' : 'Full Screen'}{' '}
              </Tooltip>
            }
          >
            <div
              className={
                fullScreen
                  ? 'th-icon ic-fulScreen-exit'
                  : 'th-icon ic-fulScreen'
              }
              role="button"
              data-testid="setFullScreenView"
              tabIndex={0}
              onClick={() => setFullScreen(!fullScreen)}
            >
              <span className="ic-title">
                {fullScreen ? 'Minimize Screen' : 'Full Screen'}{' '}
              </span>
            </div>
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

export default TableFilterHeader;
